"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = (sth) => sth !== null && typeof sth === 'object';
//# sourceMappingURL=utils.js.map